import { getCategoryLinksMarkup } from '../../components/categoryLinksMarkup';

(function () {
  var script = document.currentScript;
  if (!script) return;

  var html = getCategoryLinksMarkup({
    currentPath: window.location.pathname,
    hideCurrent: true,
  });

  script.insertAdjacentHTML('beforebegin', html);
})();
